import { t as e } from "./createLucideIcon-CJLgHpqc.js";
var t = e("chevron-right", [["path", {
	d: "m9 18 6-6-6-6",
	key: "mthhwq"
}]]);
//#endregion
export { t };

//# sourceMappingURL=chevron-right-C4-3WHKK.js.map